export const hasEffectivePricingPlan = (pricingPlanId?: number | null, shopId?: number | null): boolean => {
    const normalizedPricingPlanId = Number(pricingPlanId || 0);
    const normalizedShopId = Number(shopId || 0);

    if (!normalizedPricingPlanId) return false;
    if (normalizedPricingPlanId !== 1) return true;

    // Legacy shops (ID 2–99) can still be legitimately on plan 1. Shop 1 is a test shop.
    return normalizedShopId > 1 && normalizedShopId < 100;
};

